import React, { useEffect, useState, useRef } from 'react';
import {
  fetchJobs,
  deleteJob,
  fetchActiveJobCount,
  fetchExpiredJobCount,
  fetchAddedTodayJobCount,
  filterJobs,
} from '../services/jobService';
import JobCard from '../components/JobCard';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const filterOptions = {
  educationLevel: [
  'High School',
  'Certificate',
  'Diploma',
  'Degree',
  'Postgraduate Diploma',
  'Masters Degree',
  'PhD/Doctorate',
  'Not Specified',
],
  jobType: ['Full-time', 'Part-time', 'Internship', 'Contract', 'Temporary', 'Attachment', 'Volunteer'],
  experienceLevel: ['Intern', 'Junior', 'Mid', 'Senior', 'Lead', 'Executive'],
  organizationCategory: [
    'Banking', 'Finance', 'Healthcare', 'Education', 'Retail', 'ICT', 'Manufacturing',
    'Construction', 'Hospitality', 'Logistics', 'Real Estate', 'Agriculture',
    'Media', 'Non-profit', 'Government',
  ],

  requiredField: [
  'Accounting & Finance',
  'Administrative & Office Support',
  'Agriculture & Environmental Sciences',
  'Architecture & Design',
  'Arts, Culture & Entertainment',
  'Business & Management',
  'Community & Social Services',
  'Construction & Skilled Trades',
  'Customer Service',
  'Data Science & Analytics',
  'Education & Teaching',
  'Engineering & Technical',
  'Healthcare & Medical',
  'Hospitality, Travel & Tourism',
  'Human Resources',
  'Information Technology',
  'Law & Legal Services',
  'Logistics, Transport & Supply Chain',
  'Manufacturing & Production',
  'Marketing, Media & Communications',
  'NGO & Nonprofit',
  'Project & Program Management',
  'Research & Development',
  'Sales & Business Development',
  'Science & Laboratory',
  'Security & Protective Services',
  'Software & Web Development',
  'Sports, Fitness & Recreation',
  'Telecommunications',
  'Training & Coaching',
  'Not Specified',
],
 location: [
  'Nairobi',
  'Mombasa',
  'Kisumu',
  'Nakuru',
  'Eldoret',
  'Thika',
  'Malindi',
  'Kitale',
  'Garissa',
  'Kakamega',
  'Machakos',
  'Meru',
  'Nyeri',
  'Kericho',
  'Kisii',
  'Embu',
  'Bungoma',
  'Nanyuki',
  'Isiolo',
  'Marsabit',
  'Lodwar',
  'Wajir',
  'Mandera',
  'Homa Bay',
  'Migori',
  'Voi',
  'Narok',
  'Naivasha',
  'Limuru',
  'Kiambu',
  'Murang’a',
  'Kerugoya',
  'Chuka',
  'Siaya',
  'Busia',
  'Bomet',
  'Kapenguria',
  'Kapsabet',
  'Litein',
  'Sotik',
  'Kilifi',
  'Kwale',
  'Lamu',
  'Taveta',
  'Taita',
  'Moyale',
  'Maralal',
  'Hola',
  'Othaya',
  'Ol Kalou',
  'Kajiado',
  'Loitoktok',
  'Athi River',
  'Kangundo',
  'Mwingi',
  'Wote',
  'Kitui',
  'Kathiani',
  'Makueni',
  'Vihiga (Mbale)',
  'Bondo',
  'Oyugis',
  'Awendo',
  'Kehancha',
  'Other'
],
};

  const Home = () => {
  const [jobs, setJobs] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [activeCount, setActiveCount] = useState(0);
  const [expiredCount, setExpiredCount] = useState(0);
  const [todayCount, setTodayCount] = useState(0);
  const [filterCategory, setFilterCategory] = useState('');
  const [filterValue, setFilterValue] = useState('');
  const loadingRef = useRef(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const pageSize = 10;

  const loadJobs = async (pg = 0, category = '', value = '') => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setLoading(true); // Start loading

    const isFiltered = category && value;
    const request = isFiltered ? { [category]: value, page: pg, size: pageSize } : null;

    try {
      const data = isFiltered ? await filterJobs(request) : await fetchJobs(pg, pageSize);
      setJobs(data);
      setHasMore(data.length === pageSize);
      setPage(pg);
    } catch (err) {
      console.error('Error loading jobs:', err);
    } finally {
      loadingRef.current = false;
      setLoading(false); // Done loading
    }
  };

  const loadCounts = async () => {
    const active = await fetchActiveJobCount();
    const expired = await fetchExpiredJobCount();
    const today = await fetchAddedTodayJobCount();
    setActiveCount(active);
    setExpiredCount(expired);
    setTodayCount(today);
  };

  const handleDelete = async (id) => {
    await deleteJob(id);
    loadJobs(page, filterCategory, filterValue);
    loadCounts();
  };

  const handleEdit = (id) => {
    navigate(`/EditJob/${id}`);
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    if (!filterCategory || !filterValue) return;
    loadJobs(0, filterCategory, filterValue);
  };

  const handleClearFilter = () => {
    setFilterCategory('');
    setFilterValue('');
    loadJobs(0);
  };

  const handlePageChange = (newPage) => {
    loadJobs(newPage, filterCategory, filterValue);
  };

  useEffect(() => {
    loadJobs(0);
    loadCounts();
  }, []);

  useEffect(() => {
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes bounce {
      from { transform: translateY(0); }
      to { transform: translateY(-10px); }
    }

    div[style*="dot"]:nth-child(1) {
      animation-delay: 0s;
    }

    div[style*="dot"]:nth-child(2) {
      animation-delay: 0.2s;
    }

    div[style*="dot"]:nth-child(3) {
      animation-delay: 0.4s;
    }
  `;
  document.head.appendChild(style);
  return () => {
    document.head.removeChild(style);
  };
}, []);


  return (
    <div className="home-wrapper" style={styles.wrapper}>
      <div className="left-panel"  style={styles.leftPanel}>
        <div style={styles.headerRow}>
          <h2>Jobs Admin Dashboard</h2>
          <button style={styles.addButton} onClick={() => navigate('/add')}>➕ Add New Job</button>
        </div>

        {/* Filter Form */}
        <form onSubmit={handleFilterSubmit} style={{ display: 'flex', gap: 16, marginBottom: 20 }}>
          <select
            value={filterCategory}
            onChange={(e) => {
              setFilterCategory(e.target.value);
              setFilterValue('');
            }}
          >
            <option value="">-- Filter Category --</option>
            {Object.keys(filterOptions).map((key) => (
              <option key={key} value={key}>{key}</option>
            ))}
          </select>

          <select
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            disabled={!filterCategory}
          >
            <option value="">-- Select Value --</option>
            {filterCategory &&
              filterOptions[filterCategory]?.map((val) => (
                <option key={val} value={val}>{val}</option>
              ))}
          </select>

          <button type="submit" style={{ height: 36, padding: '0 12px' }}>Filter</button>
          <button type="button" onClick={handleClearFilter} style={{ height: 36, padding: '0 12px' }}>
            ❌ Clear Filter
          </button>
        </form>

        {loading ? (
          <div style={styles.loader}>
            <div style={styles.dot}></div>
            <div style={styles.dot}></div>
            <div style={styles.dot}></div>
          </div>
        ) : jobs.length === 0 ? (
          <div style={{
            minHeight: '300px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            width: '100%'
          }}>
            <p>No jobs found.</p>
          </div>
        ) : (
          jobs.map((job) => (
            <JobCard key={job.id} job={job} onDelete={handleDelete} onEdit={handleEdit} />
          ))
        )}


        <div style={styles.pagination}>
          <button
            disabled={page === 0}
            onClick={() => handlePageChange(page - 1)}
          >⬅ Prev</button>

          <span>Page {page + 1}</span>

          <button
            disabled={!hasMore}
            onClick={() => handlePageChange(page + 1)}
          >Next ➡</button>
        </div>
      </div>

      <div  className="right-panel" style={styles.rightPanel}>
        <div style={{ background: '#f5f5f5', height: '100%', padding: '20px' }}>
          <h4>📊 Sidebar Content</h4>
          <div style={styles.cardContainer}>
            <div style={{ display: 'flex', gap: 16, marginBottom: 20 }}>
              <div style={{ ...styles.card, backgroundColor: '#00796b', color: 'white' }}>
                <h3>Added Today</h3>
                <p style={styles.count}>{todayCount}</p>
              </div>
              <div style={{ ...styles.card, backgroundColor: '#4caf50', color: 'white' }}>
                <h3>Active Jobs</h3>
                <p style={styles.count}>{activeCount}</p>
              </div>
              <div style={{ ...styles.card, backgroundColor: '#f44336', color: 'white' }}>
                <h3>Expired Jobs</h3>
                <p style={styles.count}>{expiredCount}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
  display: 'flex',
  flexWrap: 'wrap', // allows stacking
  padding: '20px',
  boxSizing: 'border-box',
  alignItems: 'flex-start', // ensures left and right panels align at top
  },
  leftPanel: {
    flex: 3,
    paddingRight: '20px',
  },
  rightPanel: {
    flex: 2,
    borderLeft: '1px solid #ccc',
    paddingLeft: '20px',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  addButton: {
    backgroundColor: '#004d40',
    color: 'white',
    padding: '10px 14px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginTop: '20px',
  },
  card: {
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  count: {
    fontSize: '24px',
    margin: 0,
  },
  loader: {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  height: '300px',
},

dot: {
  width: '12px',
  height: '12px',
  borderRadius: '50%',
  backgroundColor: '#00796b',
  animation: 'bounce 0.6s infinite ease-in-out alternate',
},

};

export default Home;
